import { useGetPaginatedGeofences } from '../useEntity/useGeofenceV3';

// Mirrors modules/geofences/src/pages/GeofencesPage/Geofences.tsx's hasFewGeofences (also reused,
// with the same threshold, by modules/routing's ServicesDeliveriesSuggestionsBanner).
export const FEW_GEOFENCES_MAX = 2;
export const hasFewGeofences = (geofenceCount: number): boolean => geofenceCount < FEW_GEOFENCES_MAX;

const STALE_TIME_MS = 10 * 60 * 1000;

/**
 * Cheap fleet-wide geofence-count check.
 *
 * AE-2569 wrote it as the "flag OR under-threshold" fallback for geofence suggestions, which never
 * worked: `useGeofenceRecommendations` ANDs `poisRecommendations` internally, so a fleet without
 * the flag never fetched and the OR downstream of it could not enable anyone.
 *
 * Its job now is narrower and real: it is the DISPLAY gate for the geofence nudge in the floating
 * stack, mirroring the 0-1 group gate on the groups side. Without it a flagged fleet would carry a
 * permanent "see place suggestions" row in the corner no matter how many places it already has.
 *
 * Only fetches when `enabled`.
 */
const useHasFewGeofences = (fleetId: string | undefined, enabled = true) => {
  // Uma página do tamanho do limiar basta: a decisão vem do `totalElements`. Mesma key da contagem
  // do guia de configuração, então as duas compartilham a chamada.
  const { data, isLoading } = useGetPaginatedGeofences({
    filters: { page: 0, size: FEW_GEOFENCES_MAX },
    options: { enabled: !!fleetId && enabled, staleTime: STALE_TIME_MS, refetchOnWindowFocus: false, retry: false },
  });

  return { isEligible: hasFewGeofences(data?.totalElements ?? 0), isLoading };
};

export default useHasFewGeofences;
